import '@modern/theme/resellers/active/tokens.css';

import i18n from 'i18next';

import styles from '@/console/host/boot-screen.module.css';

// i18n.t, not useTranslation: the language chunk may be what failed to load.
export const BootError = () => (
  <div className={styles.screen} role="alert">
    <p className={styles.title}>{i18n.t('error:something_went_wrong')}</p>
    <button
      className={styles.action}
      onClick={() => window.location.reload()}
      type="button"
    >
      {i18n.t('common:refresh')}
    </button>
  </div>
);
